export interface Actor {
  id: string;
  name: string;
  gender: string;
  birthday: string;
  birthplace: string;
  avatar: string;
  bio: string;
  works: string[];
}

export const actors: Actor[] = [
  {
    id: 'a1',
    name: '林知远',
    gender: '男',
    birthday: '1985-03-12',
    birthplace: '中国大陆 · 北京',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20calm%20mid-aged%20asian%20man%20in%20a%20dark%20coat%2C%20neutral%20gradient%20background%2C%20soft%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=300&height=300&seq=actor-linzhiyuan-01&orientation=squarish',
    bio: '林知远以扎实的台词功底和克制的表演风格著称，擅长塑造深沉内敛的男性角色。出道二十余年，横跨电影与电视剧，多次获得表演类奖项提名。他坚持不用替身完成动作戏，被同行称为"最拼的老戏骨"。',
    works: ['beauty-and-the-beast', 'star-ocean', 'silent-verdict', 'city-inside', 'dear-doctor'],
  },
  {
    id: 'a2',
    name: '苏念',
    gender: '女',
    birthday: '1992-08-26',
    birthplace: '中国大陆 · 上海',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20an%20elegant%20young%20asian%20woman%20with%20soft%20wavy%20hair%2C%20neutral%20gradient%20background%2C%20soft%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=300&height=300&seq=actor-sunian-02&orientation=squarish',
    bio: '苏念从话剧舞台走向银幕，眼神细腻、情绪层次丰富，被誉为"天生的情感型演员"。她偏爱有难度的角色，曾在零下二十度的外景地拍摄整整一个月。近年来她开始尝试幕后，参与剧本改编工作。',
    works: ['beauty-and-the-beast', 'time-letter', 'dream-park', 'spring-rain'],
  },
  {
    id: 'a3',
    name: '陈默',
    gender: '男',
    birthday: '1988-11-04',
    birthplace: '中国大陆 · 成都',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20sharp%20featured%20asian%20man%20with%20short%20hair%2C%20neutral%20gradient%20background%2C%20soft%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=300&height=300&seq=actor-chenmo-03&orientation=squarish',
    bio: '陈默擅长高强度的动作戏与心理戏，是悬疑犯罪题材的常客。他习惯为每个角色写人物小传，甚至亲自去相关行业体验生活。导演们评价他"一进镜头就自带压迫感"。',
    works: ['changan-hours', 'silent-verdict', 'between-mountain-sea', 'city-inside', 'undercurrent'],
  },
  {
    id: 'a4',
    name: '周晚',
    gender: '女',
    birthday: '1979-05-19',
    birthplace: '中国大陆 · 西安',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20warm%20mature%20asian%20woman%20with%20gentle%20expression%2C%20neutral%20gradient%20background%2C%20soft%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=300&height=300&seq=actor-zhouwan-04&orientation=squarish',
    bio: '周晚是公认的"母亲专业户"，却从不重复自己。她在家庭题材中塑造的每一个母亲都各有血肉，令人过目难忘。生活中的她低调安静，喜欢养花和记录日常。',
    works: ['between-mountain-sea', 'city-inside', 'dear-doctor'],
  },
  {
    id: 'a5',
    name: '黎岸',
    gender: '男',
    birthday: '1983-01-30',
    birthplace: '中国香港',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20rugged%20asian%20man%20with%20a%20serious%20look%2C%20neutral%20gradient%20background%2C%20soft%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=300&height=300&seq=actor-lian-05&orientation=squarish',
    bio: '黎岸在香港影坛摸爬滚打多年，从龙套一路演到男主角。他的表演带着一股市井的烟火气，尤其擅长诠释在灰色地带挣扎的小人物。为了《暗涌》中的卧底角色，他减重十五斤并跟随退休警员生活了三个月。',
    works: ['undercurrent'],
  },
  {
    id: 'a6',
    name: '沈星野',
    gender: '女',
    birthday: '1996-09-08',
    birthplace: '中国大陆 · 广州',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20bright%20young%20asian%20woman%20with%20straight%20black%20hair%2C%20neutral%20gradient%20background%2C%20soft%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=300&height=300&seq=actor-shenxingye-06&orientation=squarish',
    bio: '沈星野是新生代中少见的"剧抛脸"，从古装到现代、从喜剧到正剧都能驾驭。她台词功底扎实，常常一条过，被剧组称为"省胶片女孩"。私下里她是个重度影迷。',
    works: ['changan-hours', 'time-letter', 'spring-rain', 'dear-doctor', 'mist-detective'],
  },
  {
    id: 'a7',
    name: '伊莎贝尔·摩尔',
    gender: '女',
    birthday: '1987-07-21',
    birthplace: '英国 · 曼彻斯特',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20an%20elegant%20western%20woman%20with%20auburn%20hair%2C%20neutral%20gradient%20background%2C%20soft%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=300&height=300&seq=actor-isabelle-07&orientation=squarish',
    bio: '伊莎贝尔·摩尔以舞台剧起家，身上带着独特的古典气质。她挑选角色极为挑剔，偏爱复杂而矛盾的人物。除了表演，她还是一名业余小提琴手，常在片场为剧组演奏。',
    works: ['star-ocean', 'fog-city', 'silent-verdict', 'polar-rescue', 'borderline', 'last-lighthouse'],
  },
  {
    id: 'a8',
    name: '亚瑟·格兰特',
    gender: '男',
    birthday: '1980-04-02',
    birthplace: '美国 · 芝加哥',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20charismatic%20western%20man%20with%20short%20dark%20hair%2C%20neutral%20gradient%20background%2C%20soft%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=300&height=300&seq=actor-arthur-08&orientation=squarish',
    bio: '亚瑟·格兰特是好莱坞最忙碌的男演员之一，兼具票房号召力与演技口碑。他为角色学习过开飞机、潜水与剑术，几乎把体验派贯彻到极致。他同时是环保基金的长期资助者。',
    works: ['beauty-and-the-beast', 'star-ocean', 'fog-city', 'polar-rescue', 'dream-park', 'borderline', 'last-lighthouse'],
  },
  {
    id: 'a9',
    name: '高桥遥',
    gender: '女',
    birthday: '1991-12-15',
    birthplace: '日本 · 北海道',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20delicate%20japanese%20woman%20with%20bob%20hair%2C%20neutral%20gradient%20background%2C%20soft%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=300&height=300&seq=actor-takahashi-09&orientation=squarish',
    bio: '高桥遥以清冷而克制的表演在日本影坛独树一帜，擅长诠释内敛而坚韧的女性。她的哭戏几乎从不流泪，却总能让人心头一紧。业余时间她从事陶艺创作。',
    works: ['fog-city', 'borderline', 'mist-detective'],
  },
  {
    id: 'a10',
    name: '韩彩英',
    gender: '女',
    birthday: '1993-06-10',
    birthplace: '韩国 · 首尔',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20graceful%20korean%20woman%20with%20long%20dark%20hair%2C%20neutral%20gradient%20background%2C%20soft%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=300&height=300&seq=actor-hanchae-10&orientation=squarish',
    bio: '韩彩英凭借细腻的情感表达成为亚洲爱情题材的代表面孔。她认为"爱情戏最难的不是甜蜜，而是告别"。她曾为一部电影学习了半年的手语。',
    works: ['time-letter', 'spring-rain', 'mist-detective'],
  },
  {
    id: 'a11',
    name: '白露',
    gender: '女',
    birthday: '1994-10-27',
    birthplace: '中国大陆 · 哈尔滨',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20cool%20asian%20woman%20with%20short%20hair%2C%20neutral%20gradient%20background%2C%20soft%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=300&height=300&seq=actor-bailu-11&orientation=squarish',
    bio: '白露身上有一股难得的英气，古装与硬核题材都能驾驭。她坚持亲自完成大部分危险镜头，被戏称为"女版替身杀手"。她也是一位资深滑雪爱好者。',
    works: ['changan-hours', 'polar-rescue', 'city-inside', 'undercurrent'],
  },
  {
    id: 'a12',
    name: '温言',
    gender: '男',
    birthday: '1990-02-14',
    birthplace: '中国大陆 · 杭州',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20of%20a%20gentle%20young%20asian%20man%20with%20soft%20features%2C%20neutral%20gradient%20background%2C%20soft%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=300&height=300&seq=actor-wenyan-12&orientation=squarish',
    bio: '温言以干净温和的气质在青春与家庭题材中广受欢迎。他相信表演最重要的是"真诚"，宁可少演也不愿重复。他还是一位小有名气的插画作者。',
    works: ['beauty-and-the-beast', 'between-mountain-sea', 'dream-park'],
  },
];